import { useCallback, useContext, useEffect, useState } from "react"
import WebSocketService from "../../../shared/websocketUtils";
import { useAuth } from "../../auth/auth-provider/auth-provider";
import { QuantityDefinitionContext } from "../../custom-contexts/quantity-definition-context/quantity-definition-context";
import axiosHttp from "../../interceptors/axios-interceptor";
import { QUANTITY_DEFINITION_API, WS_BASE_API } from "../../../constants/api";

const QuantityDefinitionProvider = ({children}) => {
    const auth = useAuth()
    const [quantityDefinitions, setQuantityDefinitions] = useState(null);
    const [counter, setCounter] = useState(0);

    useEffect(() => {
      getQuantityDefinitions();
    }, [
      auth?.token, 
      quantityDefinitions?.length,
      counter,
    ]);
  
      const getQuantityDefinitions = () => {
        const api = `${QUANTITY_DEFINITION_API}types/ordinary/${0}`;
        axiosHttp.get(api).then(
          response => {
            setQuantityDefinitions(response.data);
          }
        ).catch(
          error => {}
        );
      }

    // Add this function
    const updateSingleQuantityDefinition = useCallback((updatedQD) => {
    }, []);

  return (<>
        <QuantityDefinitionContext.Provider
            value={{
              setCounter,
              counter,
              quantityDefinitions, 
              setQuantityDefinitions,
              getQuantityDefinitions,
              updateSingleQuantityDefinition,
            }}
        >{children}
        </QuantityDefinitionContext.Provider>
    </>);
}

export default QuantityDefinitionProvider;

export const useQuantityDefinition = () => {
    return useContext(QuantityDefinitionContext);
};
